import React from 'react';
import { PostCard, PostInfo } from './PostCard';
import { PostListWrapper } from './PostList.style';
import { Content } from '../../../common/helpers/data/landingPages/fetchPostsData';
import { PostCardPlaceHolder } from './PostCardPlaceHolder';
import CardAd from '../../landingPageAds/CardAd';

export interface PostListProps {
  contents: Content[];
  adUnit?: string;
  adSect?: string;
  adSubsect?: string;
  onClickPostCard?: (post: PostInfo) => void;
}

/**
 * PostList UI component, which render a list of PostCard and Ads
 */
export const PostList: React.FC<PostListProps> = ({
  contents,
  adUnit,
  adSect,
  adSubsect,
  onClickPostCard,
}) => {
  return (
    <PostListWrapper>
      {contents.map((content, index) => {
        if (content.type === 'post') {
          return (
            <PostCard
              post={content.content}
              key={index}
              onClickPostCard={(post) => onClickPostCard(post)}
            />
          );
        } else if (content.type === 'ad') {
          return (
            <CardAd
              key={index}
              adUnit={adUnit}
              sect={adSect}
              subsect={adSubsect}
            />
          );
        } else if (content.type === 'loading-post') {
          return <PostCardPlaceHolder key={index} />;
        }
      })}
    </PostListWrapper>
  );
};
